import { Component } from '@angular/core';
import { BaseButtons } from 'buttons-loader';
import { MsFormBuilerModule } from 'ms-form-builder';
import { UnitsRoute } from 'src/domains/units/units.route';
import { BaseStringWidgetOption } from 'src/model/base/widget-options/base-string-widget-option';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [MsFormBuilerModule]
})
export class FooterComponent {
  emailInput = new BaseStringWidgetOption({
    widget: 'string',
    type: 'string',
    class: '',
    rightIcon: 'fa fa-envelope',
    placeholder: 'ایمیل خود را وارد کنید',
  });
  submit: BaseButtons<any> = {
    label: 'ثبت',
    action: () => {},
    class: 'btn btn-outline-muted button-style',
  };
  goToProductionUnit(){
    UnitsRoute.map.mainpage.production_unit_landing.navigate()
  }
  goToBdspUnit(){
    UnitsRoute.map.mainpage.bdsp_unit_landing.navigate()
  }
}
